import React from "react";

const dealfrontLogoWhite = (
  <svg
    width="25"
    height="25"
    viewBox="-0.4 -0.4 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.25517 10.21L2.2808 14.9279C1.48473 15.048 0.718672 15.1269 0 15.1633L1.98069 10.4264C2.74675 10.3853 3.50649 10.311 4.25359 10.21H4.25517Z"
      fill="#FFC940"
    />
    <path
      d="M5.87039 14.1759C5.05695 14.3907 4.24825 14.5755 3.4585 14.7272L5.42181 10.0313C6.24947 9.88758 7.05186 9.717 7.81633 9.52588L5.87197 14.1759H5.87039Z"
      fill="#56B2FF"
    />
    <path
      d="M18.3695 6.19005C18.3758 9.04421 12.8286 12.1148 7.10926 13.8269L9.04731 9.19268C12.339 8.23235 14.6545 6.97822 14.6577 6.35906C14.6624 5.52035 10.9238 3.92663 4.79688 3.69287L6.34005 0C11.3455 0.467532 18.36 2.39452 18.3695 6.19005Z"
      fill="#ffffff"
    />
  </svg>
);

export default dealfrontLogoWhite;
